// 搜索框
import search from './search.svg?inline'

// 店铺公告
import volumeFill from './volume-fill.svg?inline'

// 购物车 (样式1)
import jiagou1 from './jiagou1.svg?inline'

// 购物车 (样式2)
import jiagou2 from './jiagou2.svg?inline'

// 购物车 (样式3)
import jiagou3 from './jiagou3.svg?inline'

export { search, volumeFill, jiagou1, jiagou2, jiagou3 }
